class EcvActionDrpdwn {
    menuConfig;
    menuId;
    itemId;
    disableMenu: boolean;
    fieldKey;
    fieldModel;

    killEvent($event: any): void {
        $event.stopPropagation();
    }
}

function ecvActionDrpdwn(): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/schemaFormUtility/components/addons/directives/actionDropdown/ecvActionDrpdwn.directive.html',
        replace: true,
        controller: EcvActionDrpdwn,
        controllerAs: 'actnVm',
        scope: true,
        bindToController: {
            'menuConfig': '=',
            'menuId': '@',
            'itemId': '@',
            'disableMenu': '=',
            'fieldKey': '@',
            'fieldModel': '='
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: EcvActionDrpdwn): void => {
            
        }
    };
}
angular.module('eCareVault.common.schemaForm').directive('ecvActionDrpdwn', ecvActionDrpdwn);
